export class PersonalDataProfile {
  name!: string;
  firstSurname!: string;
  secondSurname!: string;
  identificationDocument!: string;
  civilStatusId!: string;
  civilStatusName!: string;
  fiscalAlert!: boolean;
}
